// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../imgs/logoBabitaW.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../imgs/insta.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../imgs/face.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../imgs/youtube.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rodape {
    display: flex;
    position: relative;
    justify-content: space-between;
    background-color: var(--blackMain-color);
    width: 100%;
    overflow-x: hidden;
    height: 12vh;
    box-shadow: 0px 0px 15px 0px #00000040;
    font-family: 'Poppins', sans-serif;
    font-weight: 6000;
    color: var(--white-color);
    z-index: 10000 !important;
    padding: 15px 0 10px 0; 
}


.rodape .logo{
    height: 55%;
    margin-left: 5vw;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: contain;
    background-repeat: no-repeat;
    aspect-ratio: 25/8;
    width: fit-content;
}

.rodape > div{
    margin: auto 0;
}

.rodape .socials{
    font-size: 1.18em;
    margin-right: 5vw;

}

.rodape .logosSocial{
    display: flex;
    width: max-content;
    margin-bottom: 5%;
    cursor: pointer;
}

.rodape .logosSocial div:hover{
    opacity: 0.8;
}

.rodape .logosSocial div{
    height: 40px;
    background-size: contain;
    background-repeat: no-repeat;
    margin-left: 10%;
    cursor: pointer;
}

.rodape .instaSoc{
    width: 40px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.rodape .faceSoc{
    width: 40px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

.rodape .youtSoc{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
    width: 57px;
}

.rodape .info {
    margin: auto 15px auto 50px;
}

.rodape .linksTextMain{
    display: flex;
}

.rodape .linksTextMain .areas{
    text-align: left;
    margin: 0 15px;
    cursor: pointer;
}

.rodape .linksTextMain .tituloLinks {
    font-weight: 800;
    font-family: 'Poppins', sans-serif;
}

@media(max-width: 1400px){
    .rodape {
        height: 15vh;
        padding: 1% 0;
    }
}

@media(max-width: 767px){

    .rodape .linksTextMain {
        flex-direction: column;
        width: 90%;
    }

    .rodape {
        flex-direction: column;
        align-items: center;
        padding: 7% 0;
        height: max-content;
    }

    .rodape .logo {
        height: auto;
        width: 40vw;
        margin: 2% auto 5% auto;
    }

    .rodape .socials {
        font-size: 1em;
        margin-right: 0;
        width: 80%;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 25px;
    }

    .rodape .logosSocial div {
        height: 40px;
    }

    .rodape .logosSocial div {
        margin-left: 0%;
    }

    .rodape .logosSocial {
        width: 80%;
        justify-content: space-evenly;
    }

    .rodape .lineBarRodape{
        height: 3px;
        width: 90%;
        margin: 5% auto 6% auto;
        background-color: var(--white-color);
    }

    .rodape .info {
        font-size: 1em;
        width: 90%;
        margin: auto 0 auto 0px;
    }

    .rodape .info div:nth-child(1){
        margin-bottom: 3%;
    }

    .rodape .linksTextMain{
        margin-top: 15px;
    }

    .rodape .linksTextMain .areas {
        margin: 0 ;
    }
}`, "",{"version":3,"sources":["webpack://./src/assets/css/rodape.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,kBAAkB;IAClB,8BAA8B;IAC9B,wCAAwC;IACxC,WAAW;IACX,kBAAkB;IAClB,YAAY;IAGZ,sCAAsC;IACtC,kCAAkC;IAClC,iBAAiB;IACjB,yBAAyB;IACzB,yBAAyB;IACzB,sBAAsB;AAC1B;;;AAGA;IACI,WAAW;IACX,gBAAgB;IAChB,yDAAgD;IAChD,wBAAwB;IACxB,4BAA4B;IAC5B,kBAAkB;IAElB,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;;AAErB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,wBAAwB;IACxB,4BAA4B;IAC5B,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,yDAA0C;AAC9C;;AAEA;IACI,WAAW;IACX,yDAAyC;AAC7C;;AAEA;IACI,yDAA4C;IAC5C,WAAW;AACf;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,kCAAkC;AACtC;;AAEA;IACI;QACI,YAAY;QACZ,aAAa;IACjB;AACJ;;AAEA;;IAEI;QACI,sBAAsB;QACtB,UAAU;IACd;;IAEA;QACI,sBAAsB;QACtB,mBAAmB;QACnB,aAAa;QACb,mBAAmB;IACvB;;IAEA;QACI,YAAY;QACZ,WAAW;QACX,uBAAuB;IAC3B;;IAEA;QACI,cAAc;QACd,eAAe;QACf,UAAU;QACV,aAAa;QACb,sBAAsB;QACtB,mBAAmB;QACnB,gBAAgB;IACpB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,UAAU;QACV,6BAA6B;IACjC;;IAEA;QACI,WAAW;QACX,UAAU;QACV,uBAAuB;QACvB,oCAAoC;IACxC;;IAEA;QACI,cAAc;QACd,UAAU;QACV,uBAAuB;IAC3B;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,UAAU;IACd;AACJ","sourcesContent":[".rodape {\r\n    display: flex;\r\n    position: relative;\r\n    justify-content: space-between;\r\n    background-color: var(--blackMain-color);\r\n    width: 100%;\r\n    overflow-x: hidden;\r\n    height: 12vh;\r\n    -webkit-box-shadow: 0px 0px 15px 0px #00000040;\r\n    -moz-box-shadow: 0px 0px 15px 0px #00000040;\r\n    box-shadow: 0px 0px 15px 0px #00000040;\r\n    font-family: 'Poppins', sans-serif;\r\n    font-weight: 6000;\r\n    color: var(--white-color);\r\n    z-index: 10000 !important;\r\n    padding: 15px 0 10px 0; \r\n}\r\n\r\n\r\n.rodape .logo{\r\n    height: 55%;\r\n    margin-left: 5vw;\r\n    background-image: url('../imgs/logoBabitaW.png');\r\n    background-size: contain;\r\n    background-repeat: no-repeat;\r\n    aspect-ratio: 25/8;\r\n    width: -moz-fit-content;\r\n    width: fit-content;\r\n}\r\n\r\n.rodape > div{\r\n    margin: auto 0;\r\n}\r\n\r\n.rodape .socials{\r\n    font-size: 1.18em;\r\n    margin-right: 5vw;\r\n\r\n}\r\n\r\n.rodape .logosSocial{\r\n    display: flex;\r\n    width: max-content;\r\n    margin-bottom: 5%;\r\n    cursor: pointer;\r\n}\r\n\r\n.rodape .logosSocial div:hover{\r\n    opacity: 0.8;\r\n}\r\n\r\n.rodape .logosSocial div{\r\n    height: 40px;\r\n    background-size: contain;\r\n    background-repeat: no-repeat;\r\n    margin-left: 10%;\r\n    cursor: pointer;\r\n}\r\n\r\n.rodape .instaSoc{\r\n    width: 40px;\r\n    background-image: url('../imgs/insta.png');\r\n}\r\n\r\n.rodape .faceSoc{\r\n    width: 40px;\r\n    background-image: url('../imgs/face.png');\r\n}\r\n\r\n.rodape .youtSoc{\r\n    background-image: url('../imgs/youtube.png');\r\n    width: 57px;\r\n}\r\n\r\n.rodape .info {\r\n    margin: auto 15px auto 50px;\r\n}\r\n\r\n.rodape .linksTextMain{\r\n    display: flex;\r\n}\r\n\r\n.rodape .linksTextMain .areas{\r\n    text-align: left;\r\n    margin: 0 15px;\r\n    cursor: pointer;\r\n}\r\n\r\n.rodape .linksTextMain .tituloLinks {\r\n    font-weight: 800;\r\n    font-family: 'Poppins', sans-serif;\r\n}\r\n\r\n@media(max-width: 1400px){\r\n    .rodape {\r\n        height: 15vh;\r\n        padding: 1% 0;\r\n    }\r\n}\r\n\r\n@media(max-width: 767px){\r\n\r\n    .rodape .linksTextMain {\r\n        flex-direction: column;\r\n        width: 90%;\r\n    }\r\n\r\n    .rodape {\r\n        flex-direction: column;\r\n        align-items: center;\r\n        padding: 7% 0;\r\n        height: max-content;\r\n    }\r\n\r\n    .rodape .logo {\r\n        height: auto;\r\n        width: 40vw;\r\n        margin: 2% auto 5% auto;\r\n    }\r\n\r\n    .rodape .socials {\r\n        font-size: 1em;\r\n        margin-right: 0;\r\n        width: 80%;\r\n        display: flex;\r\n        flex-direction: column;\r\n        align-items: center;\r\n        margin-top: 25px;\r\n    }\r\n\r\n    .rodape .logosSocial div {\r\n        height: 40px;\r\n    }\r\n\r\n    .rodape .logosSocial div {\r\n        margin-left: 0%;\r\n    }\r\n\r\n    .rodape .logosSocial {\r\n        width: 80%;\r\n        justify-content: space-evenly;\r\n    }\r\n\r\n    .rodape .lineBarRodape{\r\n        height: 3px;\r\n        width: 90%;\r\n        margin: 5% auto 6% auto;\r\n        background-color: var(--white-color);\r\n    }\r\n\r\n    .rodape .info {\r\n        font-size: 1em;\r\n        width: 90%;\r\n        margin: auto 0 auto 0px;\r\n    }\r\n\r\n    .rodape .info div:nth-child(1){\r\n        margin-bottom: 3%;\r\n    }\r\n\r\n    .rodape .linksTextMain{\r\n        margin-top: 15px;\r\n    }\r\n\r\n    .rodape .linksTextMain .areas {\r\n        margin: 0 ;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
